import { router } from 'expo-router';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import { SectionedContentScreenSection } from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';

interface CustomerInfo {
  name: string;
  address: string;
  occupation: string;
  dateOfBirth: string;
  citizenship: string;
}

const fieldLabels: Record<keyof CustomerInfo, string> = {
  name: 'Name',
  address: 'Home address',
  occupation: 'Occupation',
  dateOfBirth: 'Date of birth',
  citizenship: 'Citizenship',
};

type AllowedRoutes =
  | '/reactivation/personal-info'
  | '/reactivation/address-collection'
  | '/reactivation/dob'
  | '/reactivation/employment'
  | '/reactivation/citizenship';

const fieldRoutes: Record<keyof CustomerInfo, AllowedRoutes> = {
  name: '/reactivation/personal-info',
  address: '/reactivation/address-collection',
  dateOfBirth: '/reactivation/dob',
  occupation: '/reactivation/employment',
  citizenship: '/reactivation/citizenship',
};

const analyticsIds: Record<keyof CustomerInfo, string> = {
  name: 'editName',
  address: 'editAddress',
  occupation: 'editOccupation',
  dateOfBirth: 'editDob',
  citizenship: 'editCitizenship',
};

const reviewInfoHelper = (
  customerInfo: CustomerInfo | null,
  applicationId: string,
) => {
  const sections: SectionedContentScreenSection[] = [];
  const reviewInfoList: VXLNode[] = [];

  if (customerInfo) {
    (Object.keys(customerInfo) as Array<keyof CustomerInfo>).forEach((key) => {
      reviewInfoList.push({
        id: customerInfo[key],
        name: VXLComponentId.LIST_ITEM,
        props: {
          primaryCopy: customerInfo[key],
          secondaryCopy: fieldLabels[key],
          showsChevron: false,
          trailingAccessory: {
            id: 1,
            name: VXLComponentId.ICON,
            props: {
              iconKey: 'EDIT',
            },
          },
          lineFormat: ListItemLineFormat.LABEL,
          analyticsId: analyticsIds[key],
          customAttributes: {
            reactivation_flow: 'true',
            reactivation_id: applicationId,
          },
          onPress: () => {
            router.replace({
              pathname: fieldRoutes[key],
            });
          },
        },
      });
    });
  }

  sections.push({
    data: reviewInfoList,
  });

  return { sections };
};

export default reviewInfoHelper;
